import { useState, useEffect } from 'preact/compat';
import { useQuery } from '@apollo/client';
import { createPortal, Suspense } from 'preact/compat';
import DOMPurify from "dompurify";
import useLocalStorageState from 'use-local-storage-state';
import RETAILER_QUERY from '@/queries/retailerQuery';
import Modal from '@/components/Modal';
import RetailerModal from '@/components/RetailerModal';

export default function RetailerPage() {
	return (
		<>
			<RetailerBanner />
			<RetailerModal />
		</>
	);
}

function RetailerBanner() {
	const target = document.querySelector('#dutchie-banner');
	const { data, loading, error } = useQuery(RETAILER_QUERY, {
		variables: {
			retailerId: dutchie_retailer?.id,
		},
	});
	const bannerContent = DOMPurify.sanitize(data?.retailer?.banner?.html); // Sanitize HTML for security (XSS)

	if ( ! target ) {
		return null;
	}

	return createPortal(
		<>
			{loading ? (
				<div>Loading...</div>
			) : (
				<div dangerouslySetInnerHTML={{ __html: bannerContent }}></div>
			)}
		</>,
		target
	);
}